import { API, graphqlOperation } from "aws-amplify";
import { listUsedResourcesBySubjectId } from "graphql/queries";
import {
  ListUsedResourcesBySubjectIdQuery,
  UsedResource,
} from "types/graphqlapi";

export const fetchUsedResourceBySubjectIdQuery = async (
  subject_id: string
): Promise<UsedResource[] | undefined> => {
  try {
    let list: UsedResource[] = [];
    let nextToken = null;

    do {
      const result = (await API.graphql(
        graphqlOperation(listUsedResourcesBySubjectId, {
          subject_id,
          nextToken,
        })
      )) as {
        data: ListUsedResourcesBySubjectIdQuery;
      };
      const data = result.data.listUsedResourcesBySubjectId;
      const items = (data?.items || []) as UsedResource[];
      nextToken = data?.nextToken;

      list = [...list, ...items];
    } while (nextToken);

    return list;
  } catch (e) {
    // TODO エラーハンドリング
    console.error(e);
    throw e;
  }
};
